<script>
	import { setContext } from 'svelte'
	import { Router, Route, Link } from 'svelte-navigator'
	import jQuery from 'jquery'

    import './js/vendor/jquery.fullPage.min.js'

	import Header from './components/Header/Header.svelte'
	import PageCover from './components/PageCover.svelte'
	import Footer from './components/Footer.svelte'
	import PageLoader from './components/PageLoader.svelte'
	import Factsheets from './routes/Factsheets.svelte'
	import Factsheet from './routes/Factsheet.svelte'

	import Page from './routes/Page.svelte'

	import { scrolledDown } from './stores'
	import { fetchData } from './utils/functions.js';

	// Used for adding header background and hiding footer when scrolling
	let scrollPos;

	$: if (scrollPos > 10 && scrollPos < (document.body.clientHeight - window.innerHeight) - 100 ) {
		scrolledDown.update(value => true)
	} else scrolledDown.update(value => false)

	const setupFullscreenJS = () => {
		const slideElem = document.querySelectorAll('.slide')
		const arrowElem = document.querySelectorAll('.p-footer .arrow-d')
		const pageElem = document.querySelectorAll('.section')
		let pageAnchors = getAnchors()
        const mainPage = jQuery('#mainpage')
		const scrollOverflow = window.innerWidth < 601 ? false : true

        if (mainPage.height()) {
			if (!document.querySelector('html').classList.contains('fp-enabled')) {
				mainPage.fullpage({
					menu: '#qmenu',
					anchors: pageAnchors,
					verticalCentered: false,
					css3: true,
					//navigation: true,
					responsiveWidth: 601,
					//responsiveHeight: 480,
					autoScrolling: false,
					fitToSection: false,
					//scrollOverflow: scrollOverflow,
					//scrollOverflowOptions: {
					//	click: true,
					//	submit: true,
					//},
					afterRender: () => {
						// Fix video background
						//videoBg.maximage('maxcover')

						// Fix for internet explorer : adjust content height
						// Detect IE 6-11
						const isIE = /*@cc_on!@*/false || !!document.documentMode
						if (isIE) {
							const contentColumns = document.querySelectorAll('.section .content .c-columns')
							contentColumns.forEach(column => {
								column.style.height = window.innerHeight
								if (column.style.height <= window.innerHeight) {
									column.style.height = '100vh'
								}
							});
						}

						// init contact form
						// Default serer url

						// Use form define action attribute

					},
					afterResize: () => {
						const pluginContainer = jQuery(this)
						jQuery.fn.fullpage.reBuild()
					},
					afterSlideLoad: (section, origin, destination, direction) => {
						console.log('afterSlideLoad', section)
					},
					onLeave: (index, nextIndex, direction) => {

						console.log('onLeave', index, nextIndex, direction, pageElem[index-1])

						pageElem[index-1].classList.add('scrolled')

						arrowElem.forEach(element => {
							element.classList.add('gone')
						});
						pageElem.forEach(element => {
							element.classList.add('transition')
						});
						slideElem.forEach(element => {
							element.classList.remove('transition')
						});
						pageElem.forEach(element => {
							element.classList.remove('transition')
						});
					},
					afterLoad: (anchorLink, index) => {
						// Behavior after a full page is loaded
						// hide or show clock
					}
				})
			} else {
				// TODO: mainPage gets unmounted each time the route is changed, need to fix that so it's always mounted for this to work
				jQuery.fn.fullpage.destroy('All')
				pageAnchors = []
				setupFullscreenJS()
			}
			
        }
	};

	const getAnchors = () => {
		const pageSections = document.querySelectorAll('.section')
		let pageAnchors = []

		pageSections.forEach(section => {
			const anchor = section.getAttribute('data-section')
			pageAnchors.push(anchor)
		});

		return pageAnchors
	}

	// If there is a UI navigation item for this page, use its path. Otherwise use page url.
	const getURL = (page) => {
		return page.navigation ? page.navigation.path : page.url;
	}

	setContext('setupFullscreenJS', setupFullscreenJS);

</script>

<svelte:window bind:scrollY={scrollPos} />

<Router>
	{#await fetchData('pages')}

		<PageLoader />

	{:then data}

		<Header />

		{#each data as page}
		
			<Route path={getURL(page)}>

				{#if page.background}
					<PageCover background={page.background} />
				{/if}

				<Page data={page} />
			</Route>
			
		{/each}

	{:catch error}

		<p>{error}</p>

	{/await}

	<Route path='factsheets'>
		<Factsheets/>
	</Route>

	<Route path={`factsheet/:query`} let:params>
		<Factsheet query={params.query}/>
	</Route>

	<Footer />
</Router>
